import React from 'react';
import { UIText1, Link } from '@cian/ui-kit';

import styles from './styles.module.css';

export interface IRegionSuggestNotFoundContentProps {
  onChooseAgain(): void;
}

export const RegionSuggestNotFoundContent: React.FC<IRegionSuggestNotFoundContentProps> = ({ onChooseAgain }) => {
  return (
    <div className={styles['root']}>
      <UIText1 color="text-secondary-default">Регион не найден</UIText1>
      <span className={styles['action']}>
        <Link type="button" fontWeight="bold" onClick={onChooseAgain}>
          Выбрать заново
        </Link>
      </span>
    </div>
  );
};

RegionSuggestNotFoundContent.displayName = 'RegionSuggestNotFoundContent';
